import { Gender } from '@iota/iota-management-portal-v4-client';

export const Genders: string[] = [Gender.MALE, Gender.FEMALE, Gender.DIVERSE];

export const GenderDescriptions = new Map([
    ['MALE', $localize`Mr.`],
    ['FEMALE', $localize`Mrs.`],
    ['DIVERSE', $localize`Mx.`]
]);
